import { useDispatchTool, useStateTool } from 'app/store/withDevTools';
import React from 'react';
import { historicoRemessaState, initState } from './historicoRemessaState';

const HistoricoRemessaContext = React.createContext();
const HistoricoRemessaDispatchContext = React.createContext();

const HistoricoRemessaProvider = (props) => {
  const [state, dispatch] = React.useReducer(historicoRemessaState, initState);

  return (
    <HistoricoRemessaContext.Provider value={state}>
      <HistoricoRemessaDispatchContext.Provider value={dispatch}>
        {props.children}
      </HistoricoRemessaDispatchContext.Provider>
    </HistoricoRemessaContext.Provider>
  );
};

function HistoricoRemessaConsumer({ children }) {
  return (
    <HistoricoRemessaContext.Consumer>
      {(context) => {
        if (context === undefined) {
          throw new Error('HistoricoRemessaConsumer must be used within a HistoricoRemessaProvider');
        }

        return children(context);
      }}
    </HistoricoRemessaContext.Consumer>
  );
}

function useHistoricoRemessa() {
  return [
    useStateTool(HistoricoRemessaContext, 'HistoricoRemessaContext'),
    useDispatchTool(HistoricoRemessaDispatchContext, 'HistoricoRemessaDispatchContext'),
  ];
}

export { HistoricoRemessaProvider, HistoricoRemessaConsumer, useHistoricoRemessa };
